export default "__VITE_ASSET__Dv1Tm5P1__"